let menuArray = []
const splitMenuFunc = (menus)=>{
  menus.forEach(element => {
    if(element?.items?.length>0){
      menuArray.push(element.name)
      // menuArray.push(element.id)
      // menuArray.push({id:element.id,name:element.name})
      splitMenuFunc(element.items)
    }else{
      menuArray.push(element.name)
      // menuArray.push(element.id)
      // menuArray.push({id:element.id,name:element.name})
    }
  });
} 
export const splitMenu = (menus)=>{
  menuArray = []
  if(menus?.length>0){
    splitMenuFunc(menus)
    return menuArray
  }else{
    return []
  }
}

export const userHasMenu = (userMenu) =>{
  const userMenus = JSON.parse(localStorage.getItem('menu'))
  const spplittedMenu = splitMenu(userMenus)
  const hasMenu = spplittedMenu.some(r=>userMenu.indexOf(r)>= 0)
  return hasMenu
}